const buildArray = (props) => {
	let arr = [
		{ id: "property", type: "number", Label: "Community" },
		{ id: "id", type: "number", Label: "Lot ID" },
		{ id: "developer", type: "select", public: "developers", global: true },
		{ id: "subdivision", type: "select", public: "subdivisions" },
		{ id: "neighborhood", type: "select", public: "neighborhoods" },
		{ id: "lot_type", type: "select", public: "lot_types" },
		{ id: "builder", type: "select", public: "builders" },
		{ id: "lot", type: "text", after: "block" },
		{ id: "block", type: "text", after: "section_id" },
		{ id: "section_id", type: "select", public: "sections" },
		{ id: "address", type: "text", after: "lot" },
		{ id: "isd", type: "select", public: "isds" },
		{ id: "lid", type: "select", public: "lids" },
		{ id: "mud", type: "select", public: "muds" },
		{ id: "acreage", type: "number", format: "0,0.00" },
		{ id: "latitude", type: "number" },
		{ id: "longitude", type: "number" },
		{ id: "site_id", type: "select", public: "sites", global: true, isArray: true },
		{ id: "lot_status", type: "select", opts: ["Closed", "Contract", "Transferred", "Bustout", "Unsold"] },
		{ id: "spec_status", type: "select", opts: ["Completed", "Under Construction"] },
		{ id: "takedown_date", type: "date" },
		{ id: "takedown_price", type: "number", format: "$0,0.00" },
		{ id: "fence_fee", type: "number", format: "$0,0.00" },
		{ id: "base_price", type: "number", format: "$0,0.00" },
		{ id: "premium", type: "number", format: "$0,0.00" },
		{ id: "lot_premium_type", type: "select", global: true, public: "lot_premium_types" },
		{ id: "fee_marketing", type: "number", format: "$0,0.00" },
		{ id: "fee_escalation", type: "number", format: "$0,0.00" },
		{ id: "permit_issued", type: "date" },
		{ id: "permit_number", type: "text" },
		{ id: "permit_final", type: "date" },
		{ id: "construction_status", type: "select", opts: ["Vacant", "Slab", "Complete"], single: true }, // single select
		{ id: "start_date", type: "date" },
		{ id: "complete_date", type: "date" },
		{ id: "floorplan", type: "select", public: "floorplans" },
		{ id: "elevation", type: "text" },
		{ id: "brick", type: "text" },
		{ id: "stone", type: "text" },
		{ id: "trim", type: "text" },
		{ id: "siding", type: "text" },
		{ id: "garage_color", type: "text" },
		{ id: "accent_color", type: "text" },
		{ id: "roof_color", type: "text" },
		{ id: "stucco", type: "text" },
		{ id: "sqft", type: "number", format: "0,0" },
		{ id: "stories", type: "number" },
		{ id: "beds", type: "number" },
		{ id: "full_baths", type: "number" },
		{ id: "half_baths", type: "number" },
		{ id: "garage", type: "number" },
		{ id: "model", type: "boolean" },
		{ id: "is_featured", Label: "High Visibility", type: "boolean" },
		{ id: "buyer_id", type: "number" },
		{
			id: "b.primary_first",
			type: "text",
			sql: `b.primary_first`,
			Label: "Buyer First",
		},
		{
			id: "b.primary_last",
			type: "text",
			sql: `b.primary_last`,
			Label: "Buyer Last",
		},
		{
			id: "b.co_first",
			type: "text",
			sql: `b.co_first`,
			Label: "Co First",
		},
		{
			id: "b.co_last",
			type: "text",
			sql: `b.co_last`,
			Label: "Co Last",
		},
		{ id: "s.salesperson", type: "select", public: "salespeople", Label: "Salesperson", sql: "s.salesperson" },
		{ id: "sale_id", type: "number" },
		{
			id: "s.sale_date",
			type: "date",
			sql: `s.sale_date`,
			Label: "Sale Date",
		},
		{
			id: "s.closing_date",
			type: "date",
			sql: `s.closing_date`,
			Label: "Closing Date",
		},
		{
			id: "s.estimated_closing",
			type: "date",
			sql: `s.estimated_closing`,
			Label: "Estimated Closing Date",
		},
		{ id: "sale_price", type: "number", format: "$0,0" },
		{ id: "s.closing_price", type: "number", format: "$0,0", sql: "s.closing_price", Label: "Closing Price" },
		{ id: "is_price_participation", type: "boolean" },
		{ id: "date_hud_closing", type: "date" },
		{ id: "price_partic_percent", type: "number" },
		{ id: "price_partic_fee", type: "number", format: "$0,0.00" },
		{ id: "recordation_num", type: "number" },
		{ id: "feed_address", type: "text" },
		{ id: "marketing_price", type: "number", format: "$0,0" },
		{ id: "move_in_date", type: "date" },
		{ id: "in_feed", type: "boolean" },
		{ id: "in_feed_manual", type: "boolean" },
		{ id: "construction_notes", type: "text" },
		{ id: "home_comments", type: "text" },
		{ id: "admin_notes", type: "text" },
		//{ id: "estimated_price", type: "number", format: "$0,0" },
		//{ id: "mls", type: "number" },
		//{ id: "fee_gas", type: "number", format: "$0,0.00" },
		//{ id: "fee_impact_credits_received", type: "number", format: "$0,0.00" },
		//{ id: "fee_isd", type: "number", format: "$0,0.00" },
		//{ id: "lot_premium_community", type: "number", format: "$0,0.00" },
		//{ id: "has_contribution_fee", type: "boolean" },
		//{ id: "front_footage", type: "number", format: "0,0.00" },
		//{ id: "is_promo", type: "boolean" },
		//{ id: "arc_approved", type: "boolean" },
		//{ id: "true_up", type: "number" },
	]
	//? Special legacy for JAG/Viridian
	if (props?.specialFields?.lot?.construction) {
		let field = props.specialFields.lot.construction?.[props?.property]
		_.forEach(field, (v, k) => {
			let format
			if(v.prefix === '$') format = `$0,0`
			arr.push({ id: v.name, Label: v.english, type: v.type, format })
		})
	}
	
	return arr
}
export default buildArray
